export enum ClientLocaleNS {
  Common = 'common',
  HomePage = 'home_page',
  ErrorPage = 'error_page',
  RefundPage = 'refund_page',
  PrivacyPage = 'privacy_page',
  PolicyddaPage = 'policydda_page',
  CheckoutPage = 'checkout_page',
  PublicOfferPage = 'public_offer_page',
}
